export const propertySubTypes = {
    APPARTEMENT: "api.property.sub-type.APPARTEMENT",
    TOWNHOUSE: "api.property.sub-type.TOWNHOUSE",
    VILLA: "api.property.sub-type.VILLA",
    FERMETTE: "api.property.sub-type.FERMETTE",
    FOREST: "api.property.sub-type.FOREST",
    CASTLE: "api.property.sub-type.CASTLE",
    FARM: "api.property.sub-type.FARM",
    INVESTMENT: "api.property.sub-type.INVESTMENT",
    INDUSTRY: "api.property.sub-type.INDUSTRY",
    LOFT: "api.property.sub-type.LOFT",
    DUPLEX: "api.property.sub-type.DUPLEX",
    TRIPLEX: "api.property.sub-type.TRIPLEX",
    GROUND: "api.property.sub-type.GROUND",
    HOUSE: "api.property.sub-type.HOUSE",
    PENTHOUSE: "api.property.sub-type.PENTHOUSE",
    MANSION: "api.property.sub-type.MANSION",
    BUNGALOW: "api.property.sub-type.BUNGALOW",
    INDUSTRY_HALL: "api.property.sub-type.INDUSTRY_HALL",
    OTHER_BUILDING: "api.property.sub-type.OTHER_BUILDING",
    STUDIO: "api.property.sub-type.STUDIO",
    STUDENT_ACCOMMODATION: "api.property.sub-type.STUDENT_ACCOMMODATION",
    CLOSED_GARAGE: "api.property.sub-type.CLOSED_GARAGE",
    INDOOR_PARKING_SPACE: "api.property.sub-type.INDOOR_PARKING_SPACE",
    OUTDOOR_PARKING_SPACE: "api.property.sub-type.OUTDOOR_PARKING_SPACE",
    COVERED_OUTDOOR_SPACE: "api.property.sub-type.COVERED_OUTDOOR_SPACE",
    AGRICULTURAL: "api.property.sub-type.AGRICULTURAL",
    BUILDABLE: "api.property.sub-type.BUILDABLE",
    RECREATIONAL: "api.property.sub-type.RECREATIONAL",
    PASTURE: "api.property.sub-type.PASTURE",
    PARKING: "api.property.sub-type.PARKING",
    WHOLESALE_BUSINESS: "api.property.sub-type.WHOLESALE_BUSINESS",
    FREE_PROFESSION: "api.property.sub-type.FREE_PROFESSION",
    SHOWROOM: "api.property.sub-type.SHOWROOM",
    LEISURE_AND_SPORTS: "api.property.sub-type.LEISURE_AND_SPORTS",
    SHOP_AND_RETAIL: "api.property.sub-type.SHOP_AND_RETAIL",
    HORECA: "api.property.sub-type.HORECA",
    INDUSTRIAL: "api.property.sub-type.INDUSTRIAL",
    WAREHOUSE: "api.property.sub-type.WAREHOUSE",
    UNKNOWN: "api.property.sub-type.UNKNOWN",
};

export const propertyTypes = {
    APARTMENT: "api.property.type.APARTMENT",
    COMMERCIAL: "api.property.type.COMMERCIAL",
    HOUSE: "api.property.type.HOUSE",
    LAND: "api.property.type.LAND",
    OFFICE: "api.property.type.OFFICE",
    PARKING: "api.property.type.PARKING",
    UNKNOWN: "api.property.type.UNKNOWN",
};
